import { useEffect, useMemo, useState } from 'react'
import { SelectWrapper } from '../wrapper'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { ATTACHMENT_STATUSES } from '@/constants'

export const AttachmentStatusSelector = ({ onChange, value }) => {
  const { t } = useTranslation()
  const [selectedOptions, setSelectedOptions] = useState([])
  const attachmentStatusOptions = useMemo(() => {
    return Object.values(ATTACHMENT_STATUSES).map(status => {
      return { value: status, label: t(`${status}.one`) }
    })
  }, [])

  const handleChange = (options) => {
    setSelectedOptions(options)
    onChange(options)
  }

  useEffect(() => {
    if (!value) {
      setSelectedOptions({})
      return
    }

    setSelectedOptions(
      attachmentStatusOptions.filter(statusOption => value.includes(statusOption.value))
    )
  }, [value])
  return (

    <SelectWrapper label='Estado'>
      {(styles) => (

        <Select
          placeholder={t('select.one')}
          options={attachmentStatusOptions}
          isMulti
          loadingMessage={() => t('select.loading')}
          value={selectedOptions.length ? selectedOptions : null}
          styles={styles}
          menuPortalTarget={document.body}
          onChange={handleChange}
        />
      )}
    </SelectWrapper>

  )
}

AttachmentStatusSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}
